export const selectYoutubePlaylistIds = (state) => state.youtube.playlistIds;

export const selectYoutubePlaylistById = (state) => state.youtube.playlistById;

export const selectYoutubeHasFetched = (state) => state.youtube.hasFetched;

export const getYoutubePlaylists = (state) => {
  const playlistIds = selectYoutubePlaylistIds(state);
  const playlistById = selectYoutubePlaylistById(state);

  return playlistIds.map((id) => playlistById[id]);
};

export const getYoutubePlaylistById = (state, id) => {
  const playlistById = selectYoutubePlaylistById(state);

  return playlistById[id] || false;
};
